module.exports = __webpack_public_path__ + "static/media/13.68f410b9.png";